import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            深度观察
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">从业内视角解读娱乐圈那些事儿</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200/60 transition-all duration-200">
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90">
                    <i className={`${item.icon} text-sm text-primary-500`}></i>
                  </div>
                  <span className="text-xs text-background-50 font-medium">{item.duration}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}